import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-manage-folderForm',
  templateUrl: './manage-folderForm.component.html',
  styleUrls: ['./manage-folderForm.component.scss']
})

export class ManageFolderFormComponent implements OnInit {

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      formFolderName: node.formFolderName,
      formFolderID: node.formFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  //dialogRef: MatDialogRef<any, any>;

  formDialog: FormGroup;
  updateformDialog: FormGroup;

  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
    OfficeIDList:[],
    officeID:0   
  };
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  currentUser: any;
  organizationId: string;
  responseHolder: any;
  folderList: any[]=[];  
  value = ''; 
  paginatorTotalLength: any;
  //dataSource: any;
  dataCount: any;
  pageChangeEvent: any;
  pageIndex: any;
  pageSize: any;

  OfficeIDList: any=[];
  myOfficeID: any;
  ShowNoRecordFound:boolean=false;
  spinner:boolean=false;
  taskStatusID:number=0;
  cType:number=1;
  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";
  menuModulesList: any = [] = [];
  folderID:number=0;
  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService,
     private toastr: ToastrService, private statusConst: StatusConstant, 
     private reusableClass: ReusableClasses, private dialog: MatDialog,
     private settingsService: SettingService, private encryptionAlgo: EncryptionService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnInit(): void {
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;     
    }

    SelectedContact = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;      
    }

    SelectedCompany = this.menuModulesList.filter(x => x.mainModuleName == 'Company');
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;    
    }
   this.GetFormReportFolders(); 
  }

  GetFormReportFolders() {
    this.loaderService.show();   
    var ReqModel = {
      cType:this.cType,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.settingsService.getFormReportFolders(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.folderList = this.responseHolder.data;         
          if(this.folderList.length>0){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }     
        }
        else {
          this.ShowNoRecordFound=true;
          this.folderList=[];      
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound=true;
        this.folderList=[];     
        this.loaderService.hide();
      }
    });
  } 


  openDialogAddWithRef(templateRef: TemplateRef<any>) {
    this.cType=1;
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('foldername', this.formBuilder.control(''));    
    this.dialog.open(templateRef);     
  }

  AddFolder(data) {
     let ReqModel = {
      folderName: data.foldername,
      cType: this.cType,
      organizationID: Number(this.organizationId),    
      userID: this.currentUser.UID,    
      officeID:this.myOfficeID,
    }
    this.loaderService.show();   
    this.spinner=true;  
    this.formDialog.markAsPristine(); 
    this.settingsService.addFormReportFolder(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.spinner=false; 
          this.dialog.closeAll();
          this.toastr.success('Folder added successfully.', '', {
            timeOut: 3000,
          });
          this.cType=1;
          this.GetFormReportFolders();
          this.loaderService.hide();
        }else{
          this.spinner=false; 
          this.loaderService.hide(); 
        }
      }else{
        this.spinner=false; 
        this.loaderService.hide(); 
      }
    });
  }

 
  UpdateTaskDialog(templateRef: TemplateRef<any>, task: any) {
    let group = {};
    this.updateformDialog = new FormGroup(group);
    this.folderID=task.folderID;
    this.updateformDialog.addControl('foldername', this.formBuilder.control(''));
    this.updateformDialog.controls['foldername'].setValue(task.folderName);
    this.dialog.open(templateRef); 
    this.updateformDialog.markAsPristine();
  }   


  UpdateFolderName(data) {
    let ReqModel = {
     folderID:this.folderID,   
     folderName: data.foldername,
     organizationID: Number(this.organizationId),  
     userID: this.currentUser.UID,  
     officeID:this.myOfficeID,
   }
   this.loaderService.show();   
   this.spinner=true;  
   this.updateformDialog.markAsPristine(); 
   this.settingsService.renameFormReportFolder (ReqModel).subscribe(response => {
     if (response != undefined) {
       this.responseHolder = response;
       this.loaderService.hide();
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.spinner=false;
         this.dialog.closeAll();     
         this.toastr.success('Folder name update successfully.', '', {
           timeOut: 3000,
         });
         this.GetFormReportFolders();        
         this.loaderService.hide();
       }else{
         this.spinner=false; 
         this.loaderService.hide(); 
         this.toastr.error('Folder name update failed.', '', {
          timeOut: 3000,
        });
       }
     }else{
      this.spinner=false; 
      this.loaderService.hide(); 
      this.toastr.error('Folder name update failed.', '', {
       timeOut: 3000,
     }); 
     }
   });
  }


 deleteFolderForm(data: any) { 
    var message = `Are you sure you want to delete?`;  
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });  
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();       
        var ReqModel ={
          folderID: data.folderID,        
          organizationID: Number(this.organizationId),  
          userID: this.currentUser.UID,  
          officeID:this.myOfficeID,
        }        
        this.settingsService.removeFormReportFolder(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.toastr.success('Folder deleted successfully.', '', {
                timeOut: 3000,
              });
              this.GetFormReportFolders();
              this.loaderService.hide();
            }
          }
        });
      }
    });
 }  
  

 UpdateStatusToggle(task: any, event: any) {
  this.loaderService.show();
  var ReqModel = {
    folderID: task.folderID,    
    isActive: event.checked,
    organizationID: Number(this.organizationId),  
    userID: this.currentUser.UID,  
    officeID:this.myOfficeID,
  }
   this.settingsService.activateFormReportFolder(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.toastr.success('Status updated successfully.', '', {
          timeOut: 3000,
        });
        this.GetFormReportFolders();
        this.loaderService.hide();
      }else{
        this.loaderService.hide();
        this.toastr.error('Status update failed.', '', {
          timeOut: 3000,
        });
      }
    }else{
      this.loaderService.hide();
      this.toastr.error('Status update failed.', '', {
        timeOut: 3000,
      });
    }
  });
 }


  close() {
    this.formDialog.reset();    
    this.dialog.closeAll();
  }

  closeUpdate(){
    this.updateformDialog.reset();
    this.dialog.closeAll();
  }


  selectForm(templateRef: TemplateRef<any>, task) {
    return;
    this.dialog.open(templateRef, {
      panelClass: 'selectTemplate',
    });
    this.activeNode = "";
    this.dataSource.data = [];
    this.selectButtonShow = false;
    this.isShowForm = true;
    this.isSharedWithMe = false;
    this.SharedWithMeactive = false;
    this.menuHeaderMyDrive = [];
    this.menuHeader = [];
    this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
  }

  closeForms() {   
    // For Import Template //
    this.menuHeader = [];
    this.FormFolderListMiddleSection = [];
    this.FormFolderList = [];
    this.activeNode = "";
    this.SharedWithMeactive = false;
    this.selectButtonShow = false;   

    this.dialog.closeAll();
  }
  //================== For Forms ====================//

  activeNode: string = "";
  hierarchyList: any;
  breadCrumMenu: any = [];
  FormsubFolderFolderList: any;
  selectButtonShow: boolean = false;
  PlaceholderName: string = "";
  PlaceholderID: string = "";
  DocumentFolderID: string = "";
  FormID: string = "";
  fileManagerID: string = "";
  PlaceholderNameFound: boolean = false;
  SharedWithMeFormFolderList: any = [] = [];
  SharedWithMeMyDriveFolderList: any = [] = [];
  isShowForm: any = true;
  isSharedWithMe: any = false;
  isShowMyDrive: any = false;
  isSharedWithMeMyDrive: any = false;
  SharedWithMeactive: boolean = false;
  SharedWithMeMyDriveactive: boolean = false;
  menuHeaderMyDrive: any = [];
  menuHeader: any = [];
  databaseId: string;
  FormFolderList: any;
  FormFolderListMiddleSection: any = ([] = []);
  parentID: number = 0;
  TypeId: number;

  radioChange(form, FormOrShared) {
    if (FormOrShared == "SharedWithMe") {
      this.activeNode = "";
      this.SharedWithMeFormFolderList.forEach(e => {
        e.isChecked = false
      });
    }
    if (FormOrShared == "MyForm") {
      this.FormFolderListMiddleSection.forEach(e => {
        e.isChecked = false
      });
    }

    if (form.type == 1 && FormOrShared == "MyForm") {
      this.selectButtonShow = false;
      this.getform(form, FormOrShared);
    }

    if (form.type == 2) {
      if (this.PlaceholderNameFound == true) {
        this.PlaceholderName = form.name;
        if (this.PlaceholderID == undefined)
          this.PlaceholderID = "0";
      }
      this.FormID = form.id;
      this.selectButtonShow = true;
      if (FormOrShared == "MyForm") {
        this.FormFolderListMiddleSection.forEach(e => {
          if (e.id == form.id) {
            e.isChecked = true
          }
        });
      }
      if (FormOrShared == "SharedWithMe") {
        this.SharedWithMeFormFolderList.forEach(e => {
          if (e.id == form.id) {
            e.isChecked = true
          }
        });
      }
    }
  }

  getform(form, FormOrSharedWithMe) {
    if (FormOrSharedWithMe == "MyForm") {
      this.activeNode = form.id;
    }
    if (FormOrSharedWithMe == "SharedWithMe") {
      this.activeNode = "";
    }
    this.TypeId = form.type;
    var type = form.type;
    //{ 1- Folder, 2- Form}
    if (type == 1) {
      var ReqModel = {
        formFolderID: form.id,
        formFolderName: '',
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        OfficeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
      };
      this.settingsService.getFormFolderWithFormTemplates(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.FormFolderListMiddleSection = this.responseHolder.data;           
            this.FormFolderListMiddleSection=this.FormFolderListMiddleSection.filter(x=>x.type == 2 && x.formType==3);
     
            this.parentID = form.id;

            this.menuHeader.push({
              label: form.name,
              id: form.id,
              icon: 'navigate_next',
            });

            this.menuHeader = this.menuHeader.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);

          } else {
          }
        } else {
        }
      });
    } else {
    }
  }

  breadCrumb(menu, index) {
    this.menuHeader.splice(index + 1, this.menuHeader.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.FormFolderList = menu[index].items;
    }
    var data = this.menuHeader[index];
    this.getformnavigate(data);
    this.selectButtonShow = false;
    this.parentID = data.id;
  }


  getformnavigate(form) {
    this.selectButtonShow = false;
    this.activeNode = form.id;
    var ReqModel = {
      formFolderID: form.id,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.settingsService.getFormFolderWithFormTemplates(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FormFolderListMiddleSection = this.responseHolder.data;  
          this.FormFolderListMiddleSection=this.FormFolderListMiddleSection.filter(x=>x.type == 2 && x.formType==3);
        } else {
        }
      } else {
      }
    });
  }

  GetAllForms() {
    this.activeNode = "";
    this.dataSource.data = [];
    this.selectButtonShow = false;
    this.isShowForm = true;
    this.isSharedWithMe = false;
    this.isShowMyDrive = false;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeactive = false;
    this.menuHeader = [];
    this.menuHeaderMyDrive = [];
    this.getFormFolderListLeftPanel();
    this.getFormFolderListMiddlePanel();
  }

  getFormFolderListLeftPanel() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.loaderService.show();
    this.settingsService.getFormFolderList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FormFolderList = this.responseHolder.data;
          if (this.FormFolderList.length > 0) {
            this.dataSource.data = this.FormFolderList;
          }
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });

  }

  getFormFolderListMiddlePanel() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: '',
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    };
    this.settingsService.getFormFolderWithFormTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.FormFolderListMiddleSection = this.responseHolder.data;        
          this.FormFolderListMiddleSection.forEach(e => {
            e.isChecked = false
          });
        } else {
        }
      } else {
      }
    });
  }

  getFormFolderWithTemplatesLeftPanel(form) {
    this.selectButtonShow = false;
    this.activeNode = form.formFolderID;
    var ReqModel = {
      formFolderID: form.formFolderID,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.settingsService.getFormFolderWithFormTemplates(ReqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FormsubFolderFolderList = this.responseHolder.data;          
          this.FormsubFolderFolderList=this.FormsubFolderFolderList.filter(x=>x.type == 2 && x.formType==3);
  
          this.settingsService.GetParentFormFolderHierarchy(ReqModel).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConst.statusSuccess) {
                this.hierarchyList = response.data.hierarchy;
                if (this.hierarchyList == null || this.hierarchyList == undefined) {
                  this.breadCrumMenu = [];
                  this.menuHeader = this.breadCrumMenu;
                  this.FormFolderListMiddleSection = this.FormsubFolderFolderList;
                  this.parentID = form.parentID;
                } else {
                  this.breadCrumMenu = [];
                  this.hierarchyList.forEach(e => {
                    this.breadCrumMenu.push({ label: e.formFolderName, id: e.formFolderID, icon: 'navigate_next' });
                  });
                  this.menuHeader = this.breadCrumMenu;
                  this.FormFolderListMiddleSection = this.FormsubFolderFolderList;
                  this.parentID = form.parentID;
                  this.isShowForm = true;
                  this.isSharedWithMe = false;
                  this.SharedWithMeactive = false;
                }
              }
            }
          });
        }
        else {
        }
      }
      else {
      }
    });

  }

  getIsFavorite(isFavorite) {
    isFavorite = isFavorite.isFavorite;
    return isFavorite;
  }

  breadCrumbMainClick() {
    this.FormFolderListMiddleSection = [];
    this.getFormFolderListMiddlePanel();
    this.menuHeader = [];
    this.TypeId = 0;
    this.parentID = 0;
    this.selectButtonShow = false;
    this.activeNode = "";
  }

  // =========== For Shared with me  =========// 

  getSharedWithMe() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.settingsService.getFormFolderSharedWithMeList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.SharedWithMeFormFolderList = this.responseHolder.data;
          this.SharedWithMeFormFolderList.forEach(e => {
            e.isChecked = false
          });
          if (this.SharedWithMeFormFolderList != null) {
            this.SharedWithMeFormFolderList.map((res) => {
              if (res.sharedbyFirstName != null) {
                res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
              }
              if (res.sharedbyLastName != null) {
                res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
              }
              return res;
            });
          }

          this.selectButtonShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = true;
          this.SharedWithMeactive = true;
          this.SharedWithMeMyDriveactive = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = false;
          this.activeNode = "";
          this.menuHeader = [];
          this.parentID = 0;
        }
        else {
          this.SharedWithMeFormFolderList = [];
          this.selectButtonShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = true;
          this.SharedWithMeactive = true;
          this.SharedWithMeMyDriveactive = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = false;
          this.activeNode = "";
          this.menuHeader = [];
          this.parentID = 0;
        }
      }
      else {
      }
    });
  }


  breadCrumbMainSHaredWithMeClick() {
    this.selectButtonShow = false;
    this.getSharedWithMe();
    this.menuHeader = [];
    this.parentID = 0;
  }

  getFormFolderWithFormTemplatesSharedWithMe(form) {
    this.TypeId = form.type;
    var type = form.type;
    //{ 1- Folder, 2- Form}
    if (type == 1) {
      var ReqModel = {
        formFolderID: form.id,
        formFolderName: '',
        permissionType: form.permissionType,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        OfficeID: this.myOfficeID,
        databaseID: Number(this.databaseId),
      };
      this.settingsService.getFormFolderWithFormTemplatesSharedWithMe(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.SharedWithMeFormFolderList = this.responseHolder.data;
            if (this.SharedWithMeFormFolderList != null) {
              this.SharedWithMeFormFolderList.map((res) => {
                if (res.sharedbyFirstName != null) {
                  res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
                }
                if (res.sharedbyLastName != null) {
                  res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
                }
                return res;
              });
            }
            this.parentID = form.id;
            this.menuHeader.push({
              label: form.name,
              id: form.id,
              icon: 'navigate_next',
              permissionType: form.permissionType,
            });

            this.menuHeader = this.menuHeader.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);

          } else {
          }
        } else {
        }
      });
    } else {
    }
  }


  SelectFormSubmit() {

  }

 
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.folderList, event.previousIndex, event.currentIndex);  
    var record:any=[]=[];
    var reOrdersList:any=[]=[];
    record = this.folderList;
    if(record.length>0){     
      reOrdersList=[];
      for (let i = 0; i < record.length; i++) {     
        var obj={
          folderID: record[i].folderID,          
          position: i+1
        }
        reOrdersList.push(obj);
      }     

      var reqModel={
        cType:this.cType,       
        folderOrdering:reOrdersList,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        databaseID: Number(this.databaseId)
      }
      this.loaderService.show();
      this.settingsService.reorder3CFormFolders(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {          
            this.GetFormReportFolders();
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }


  OnChange3C($event) {    
    this.cType=Number($event.value); 
    this.GetFormReportFolders();   
  }

  OnChange3CAddUpdate($event) {    
    this.cType=Number($event.value); 
   // this.GetFormReportFolders();   
  }

}

interface FoodNode {
  formFolderName: string;
  children?: FoodNode[];
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}